"use client"

import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import { Button, ButtonDock, Header, MessageCard, InputField } from "@dalmatech/ui"
import useForm from "@/shared/hooks/use-form"
import { ROUTES } from "@/shared/routing/routes"
import { type SubmitHandler } from "react-hook-form"
import { type PetNameSchema, petNameSchema } from "../../schemas/pet-name.schema"
import * as styles from "./pet-name.styled"
import { newSubscriptionFlowService } from "@/store/machine"
import { useActor } from "@xstate/react"
import { useRouter } from "next/navigation"
import { getPetById, getPetIndex } from "../../helpers/helpers"
import * as R from "ramda"

export const PetNamePage = () => {
  const router = useRouter()
  const [state, send] = useActor(newSubscriptionFlowService)
  const { t } = useClientTranslation("pet-name-page")
  const currentPet = getPetById(state.context.quote?.pets || [], state.context.currentPetId)
  const currentPetIdx = getPetIndex(state.context.quote?.pets || [], currentPet?.id)
  const { register, handleSubmit, formState } = useForm(petNameSchema, {
    defaultValues: {
      name: state.context.quote?.pets?.[currentPetIdx || 0]?.name || '',
    },
  })

  const onSubmit: SubmitHandler<PetNameSchema> = (values) => {
    send({
      type: "ADD_PET_NAME",
      petName: values.name,
      petId: currentPet?.id || null
    })
    router.push(ROUTES.petInfo.path)
  }

  const isAddingNewPet = R.any(R.has("created_at"))(state.context.quote?.pets || [])
  const titleKey = isAddingNewPet ? "nthPetTitle" : "title"
  const pageTitle = t(titleKey)
  const infoCardPrefix = isAddingNewPet ? "info-card-multi" : "info-card"

  return (
    <div className={styles.root}>
      <Header>{pageTitle}</Header>
      <form onSubmit={handleSubmit(onSubmit)} noValidate className={styles.form}>
        <InputField
          type="text"
          placeholder={t("pet-name-placeholder")}
          error={formState.errors.name?.message}
          {...register("name")}
        />

        <MessageCard title={t(`${infoCardPrefix}.title`)} description={t(`${infoCardPrefix}.description`)} />
        <ButtonDock withSpacers={false} isSingleButton isFixedOnMobile>
          <Button type="submit" className="w-[36.750rem]" disabled={!formState.isValid} size="lg">
            {t("cta")}
          </Button>
        </ButtonDock>
      </form>
    </div>
  )
}
